import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledCard = styled(Link)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 22rem;
  margin: 0 0.5rem 2rem;
  text-decoration: none;
  box-shadow: 0 0.25rem 0.5rem rgba(0,0,0,0.25);
  transition: 0.5s ease all;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 0.5rem 0.75rem rgba(0,0,0,0.25);
    transition: 0.5s ease all;
  }

  .banner {
    width: 100%;
    height: 12.5rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .text-area {
    padding: 2rem;
  }

  .title {
    display: block;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 1.5rem;
    margin: 0 0 2rem;
    color: ${t => t.theme.blue};
  }

  .description {
    display: block;
    color: black;
  }
`;

const propTypes = {
  img: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.string,
  description: PropTypes.string,
};

const defaultProps = {
  img: '/images/Locations/350_Island.jpeg',
  title: 'Title',
  link: '/',
  description: '',
};

function Card({
  img,
  title,
  link,
  description,
}) {
  return (
    <StyledCard to={link} className="Card">
      <div className="banner" alt="banner" style={{ backgroundImage: `url(${img}` }} />
      <div className="text-area">
        <span className="title">
          {title}
        </span>
        <span className="description">
          {description}
        </span>
      </div>
    </StyledCard>
  );
}

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;

export default Card;



// WEBPACK FOOTER //
// ./src/Components/Card/index.jsx